import React from 'react';
import Slider from 'react-slick'

function SamplePrevArrow(props) {
  const {onClick} = props
  return (
    <div className="carousel-buttons">
      <i className="fa fa-chevron-left" aria-hidden="true"
        onClick={onClick}
      ></i>
    </div>
  );
}

function SampleNextArrow(props) {
  const {onClick} = props
  return (
    <div className="carousel-buttons">
      <i className="fa fa-chevron-right" aria-hidden="true"
        onClick={onClick}
      ></i>
    </div>

  );
}

class Carousel extends React.Component{
  render() {
    let infinite;
    if (this.props.typeCarousel === "hero" && this.props.home[0].data.heroImages.length === 1){
      infinite = false;
    } else {
      infinite = true;
    }
    var settings = {
      dots: true,
      infinite: infinite,
      speed: 500,
      slidesToShow: this.props.slidesToShow,
      slidesToScroll: 1,
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />
    };
    let carousel;
    if (this.props.typeCarousel === "instagram"){
      carousel = <div className='carousel instagram'>
        <Slider {...settings}>
          {this.props.instagram[0].data.map((picture, i) => <div key={i}><a href={picture.link} target="_blank"><img alt={"instagram" +{i}} src={picture.images.low_resolution.url}/></a></div>)}
        </Slider>
      </div>
    } else if (this.props.typeCarousel === "hero"){
      carousel = <div className='carousel hero'>
        <Slider {...settings}>
          {this.props.home[0].data.heroImages.map((picture, i) => <div key={i}><a href={picture.imageTarget}><img alt={picture.altText} loading="lazy"  src={picture.imageUrl}/></a></div>)}
        </Slider>
      </div>
    }

    return (
      carousel
    );
  }
}

export default Carousel


// WEBPACK FOOTER //
// ./src/components/Carousel.js